import React, { Component } from 'react';
import styled from 'styled-components';
import { getTheme } from '../../global/utils';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Loading from '../../components/loading/Loading';

require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);

const WrapperDiv = styled.div`
  position: relative;
  min-height: 150px; //Displays the loading component in absence of content
  .highcharts-exporting-group {
    transform: translateY(-12px);
  }
  .highcharts-tooltip-box {
    fill: ${getTheme('black', '_50')};
    fill-opacity: 0.6;
    stroke-width: 0;
  }

  .highcharts-tooltip text {
    fill: ${getTheme('textColor', 'white')} !important;
    padding-bottom: 0 !important;
    text-shadow: 0 0 3px black;
  }

  .highcharts-tooltip__header {
    display: block;
    font-size: ${getTheme('fontSize', 'note')};
    margin-bottom: ${getTheme('spacer', 's')} !important;
  }
  .highcharts-contextmenu {
    max-height: 90%;
    overflow: auto;
  }
`;

class LineChart extends Component {
  render() {
    const options = {
      chart: {
        height: 250,
        style: {
          fontFamily: 'inherit',
        },
      },
      colors: ['#80B1D3', '#B3DE69', '#FCCDE5', '#FDB462', '#FB8072'],
      credits: {
        enabled: false,
      },
      title: {
        text: null,
      },
      legend: {
        align: 'left',
        verticalAlign: 'top',
        borderWidth: 0,
        itemDistance: 16,
        x: 0,
        y: -16,
      },
      plotOptions: {
        series: {
          marker: {
            lineWidth: 2,
            symbol: 'circle',
          },
        },
      },
      tooltip: {
        headerFormat: '<span class="highcharts-tooltip__header">{point.key}</span><br />',
        pointFormat:
          '<span style="color:{point.color}">\u25CF </span> <b>{point.y} {series.name}</b><br/>',
        crosshairs: true,
        shared: true,
      },
      series: this.props.chartData.series,
      xAxis: this.props.chartData.xAxis,
      yAxis: this.props.chartData.yAxis,
    };

    return (
      <WrapperDiv>
        {!this.props.chart_loading && <HighchartsReact highcharts={Highcharts} options={options} />}
        {this.props.chart_loading && <Loading heading="Loading chart" text="It might take a while." />}
      </WrapperDiv>
    );
  }
}
export default LineChart;



// WEBPACK FOOTER //
// ./src/components/charts/LineChart.js